import React from "react";
import { PulseLoader } from "react-spinners";

const Loading = (props) => {
    return (
        <div className="flex flex-col justify-center items-center">
            <PulseLoader sizeUnit={"px"} size={20} color={"#12ce66"} loading={true} />
        </div>
    );
};
export default Loading;
